var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E84142"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1977 5.93719C20.5047 4.74034 19.4024 4.74034 18.7095 5.93719L6.12679 28.0947C5.43387 29.3073 6.0008 30.2679 7.38663 30.2679H13.7016C14.9772 30.1892 16.1268 29.512 16.8197 28.4411L24.426 15.26C24.9772 14.1262 24.9772 12.7876 24.426 11.6537L22.1583 7.66947L21.1977 5.93719ZM29.56 20.5199C28.8671 19.323 27.749 19.323 27.056 20.5199L22.6623 28.0947C21.9852 29.2915 22.5521 30.2679 23.9222 30.2679H32.6151C34.0009 30.2679 34.5679 29.2915 33.8749 28.0947L29.56 20.5199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/avax.506dd2ec417f1211f521fa1a6d0d0ca2.svg";
export { ForwardRef as ReactComponent };